"use strict";
// This file contains a generic ProgressManager which any lab can include,
// if it wants to make progress without reloading the page.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialValidationState = exports.Validator = void 0;
// Abstract class that validates a set of conditions. How
// the validation works is up to the implementor.
var Validator = /** @class */ (function () {
    function Validator() {
    }
    return Validator;
}());
exports.Validator = Validator;
var getInitialValidationState = function () { return ({
    hasConditions: false,
    satisfied: false,
    message: null,
    index: 0,
}); };
exports.getInitialValidationState = getInitialValidationState;
var ProgressManager = /** @class */ (function () {
    function ProgressManager(onProgressChange) {
        this.levelData = undefined;
        this.onProgressChange = onProgressChange;
        this.currentValidationState = (0, exports.getInitialValidationState)();
    }
    /**
     * Update the ProgressManager with level data for a new level.
     * Resets validation status internally.
     */
    ProgressManager.prototype.onLevelChange = function (levelData) {
        this.levelData = levelData;
        this.resetValidation();
    };
    ProgressManager.prototype.setValidator = function (validator) {
        this.validator = validator;
    };
    ProgressManager.prototype.getCurrentState = function () {
        return this.currentValidationState;
    };
    ProgressManager.prototype.updateProgress = function () {
        var _a;
        var validations = (_a = this.levelData) === null || _a === void 0 ? void 0 : _a.validations;
        if (!validations || !this.validator) {
            return;
        }
        // Find out from the lab-specific code whether we should be trying to
        // check conditions at the moment.  Otherwise, we might get a fail
        // when we shouldn't have even been checking.
        if (!this.validator.shouldCheckConditions()) {
            return;
        }
        // Give the lab-specific code a chance to check conditions.  We do
        // it once each update in case it's expensive, and since conditions
        // can be used by multiple validations.
        this.validator.checkConditions();
        // Go through each validation to see if we have a match.
        for (var _i = 0, validations_1 = validations; _i < validations_1.length; _i++) {
            var validation = validations_1[_i];
            if (validation.conditions) {
                // Ask the lab-specific validator if this validation's
                // conditions are met.
                if (this.validator.conditionsMet(validation.conditions)) {
                    if (!this.currentValidationState.satisfied) {
                        this.currentValidationState.satisfied = validation.next;
                        this.currentValidationState.message = validation.message;
                        this.onProgressChange();
                    }
                    return;
                }
            }
            else {
                this.currentValidationState.message = validation.message;
            }
        }
        this.onProgressChange();
    };
    ProgressManager.prototype.resetValidation = function () {
        var _a;
        if (this.validator) {
            // Give the lab the chance to clear accumulated satisfied conditions.
            this.validator.clear();
        }
        var hasConditions = (((_a = this.levelData) === null || _a === void 0 ? void 0 : _a.validations) && this.levelData.validations.length > 0) ||
            false;
        this.currentValidationState = {
            hasConditions: hasConditions,
            satisfied: false,
            message: null,
            // Ensure that the validation feedback UI is rendered fresh.  This index is
            // used as part of the key for that React component; having a unique value
            // ensures that the UI is rendered fresh, and any apperance animation is
            // played again, even if it's the same message as last time.
            index: this.currentValidationState.index + 1,
        };
        this.onProgressChange();
    };
    return ProgressManager;
}());
exports.default = ProgressManager;
